import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { spacing } from 'ui/theme';
import { Asset } from '../../../types';

const Preview = styled.div<{ $imgSrc: string; $height: number | string; $width: number | string }>`
  background-image: url(${({ $imgSrc }) => $imgSrc});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: ${spacing.threeEights};
  flex: 0 0 auto;
  height: ${({ $height }) => (typeof $height === 'number' ? pxToRem($height) : $height)};
  width: ${({ $width }) => (typeof $width === 'number' ? pxToRem($width) : $width)};
`;

export const ImagePreview = ({
  image,
  height,
  width,
}: {
  image: Asset;
  height: number | string;
  width: number | string;
}) => (
  <Preview
    data-test={`preview-${image.id}`}
    $imgSrc={image.url || ''}
    $height={height}
    $width={width}
  />
);
